import { ImageTabs } from '@/components/features/images'
import { AnimatedOutlet } from '@/components/ui'

export function ImagesPage() {
  return (
    <div>
      {/* Tab Navigation */}
      <div className="px-6 md:px-8 pt-6">
        <ImageTabs />
      </div>

      {/* Tab Content with transition */}
      <AnimatedOutlet />
    </div>
  )
}
